/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetUnreadNotificationCountResponse
 */
export interface GetUnreadNotificationCountResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetUnreadNotificationCountResponse
     */
    count: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the GetUnreadNotificationCountResponse interface.
 */
export function instanceOfGetUnreadNotificationCountResponse(value: object): value is GetUnreadNotificationCountResponse {
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function GetUnreadNotificationCountResponseFromJSON(json: any): GetUnreadNotificationCountResponse {
    return GetUnreadNotificationCountResponseFromJSONTyped(json, false);
}

export function GetUnreadNotificationCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUnreadNotificationCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'count': ApiUserTasksGetPageParameterFromJSON(json['count']),
    };
}

export function GetUnreadNotificationCountResponseToJSON(json: any): GetUnreadNotificationCountResponse {
    return GetUnreadNotificationCountResponseToJSONTyped(json, false);
}

export function GetUnreadNotificationCountResponseToJSONTyped(value?: GetUnreadNotificationCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': ApiUserTasksGetPageParameterToJSON(value['count']),
    };
}

